function isWorking(state) {
    return state.content.isWorking.mediaSingle
}

function selectedMedia(state) {
    return state.content.selected.media
}

function mediaPendingApprovalCount(state) {
    return state.content.counts.pendingApprovalMedia.count
}

function mediaPendingPushCount(state) {
    return state.content.counts.pendingPushMedia.count
}

function mediaPendingTestCount(state) {
    return state.content.counts.pendingTestMedia.count
}

export { isWorking, mediaPendingApprovalCount, mediaPendingPushCount, mediaPendingTestCount, selectedMedia }
